/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { PackagingFragmentFragmentDoc } from './packagingFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Gtin_Type_Enum =
  | 'GTIN_8'
  | 'GTIN_12'
  | 'GTIN_13'
  | 'GTIN_14';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingsFromCustomPriceListQueryVariables = Exact<{
  customPriceListId: string;
}>;


export type PackagingsFromCustomPriceListQuery = { custom_price_list_packaging: Array<{ id: string, discount: number, packaging: { id: string, company_id: string, base_unit_id: string, product_id: string, gtin: string | null, gtin_type: Types.Gtin_Type_Enum | null, sku: number, price: number, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, net_content: number | null, base_unit: { id: string, sku: number | null, billing_type: Types.Billing_Type_Enum, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, unit_type: Types.Base_Unit_Type_Enum | null, unit_quantity: number | null, unit_net_content: number | null, suggested_retail_price: number | null, availability: Types.Availability_Status_Enum, product_id: string, main_photo: { path: string, domain: string | null } | null, photos: Array<{ photo: { path: string, domain: string | null } }>, social_tags: Array<{ values: { [key: string]: any } | null, type: Types.Social_Tag_Type_Enum, priority: number, level: number }> }, product: { name: string, sku: number, sub_family: string, vat_rate: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } } | null }> };


export const PackagingsFromCustomPriceListDocument = /*#__PURE__*/ gql`
    query PackagingsFromCustomPriceList($customPriceListId: uuid!) {
  custom_price_list_packaging(
    where: {custom_price_list_id: {_eq: $customPriceListId}, packaging: {base_unit: {availability: {_eq: AVAILABLE}}}}
    order_by: [{discount: desc}, {packaging: {product: {name: asc}}}, {packaging: {base_unit: {unit_type: asc}}}, {packaging: {trade_item_unit_descriptor: asc}}]
  ) {
    id
    discount
    packaging {
      ...packagingFragment
    }
  }
}
    ${PackagingFragmentFragmentDoc}`;

/**
 * __usePackagingsFromCustomPriceListQuery__
 *
 * To run a query within a React component, call `usePackagingsFromCustomPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingsFromCustomPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingsFromCustomPriceListQuery({
 *   variables: {
 *      customPriceListId: // value for 'customPriceListId'
 *   },
 * });
 */
export function usePackagingsFromCustomPriceListQuery(baseOptions: Apollo.QueryHookOptions<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables> & ({ variables: PackagingsFromCustomPriceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>(PackagingsFromCustomPriceListDocument, options);
      }
export function usePackagingsFromCustomPriceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>(PackagingsFromCustomPriceListDocument, options);
        }
// @ts-ignore
export function usePackagingsFromCustomPriceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>;
export function usePackagingsFromCustomPriceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsFromCustomPriceListQuery | undefined, PackagingsFromCustomPriceListQueryVariables>;
export function usePackagingsFromCustomPriceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>(PackagingsFromCustomPriceListDocument, options);
        }
export type PackagingsFromCustomPriceListQueryHookResult = ReturnType<typeof usePackagingsFromCustomPriceListQuery>;
export type PackagingsFromCustomPriceListLazyQueryHookResult = ReturnType<typeof usePackagingsFromCustomPriceListLazyQuery>;
export type PackagingsFromCustomPriceListSuspenseQueryHookResult = ReturnType<typeof usePackagingsFromCustomPriceListSuspenseQuery>;
export type PackagingsFromCustomPriceListQueryResult = Apollo.QueryResult<PackagingsFromCustomPriceListQuery, PackagingsFromCustomPriceListQueryVariables>;